import { FormState } from '@vtex/admin-ui-form'
import { useWatchAlias } from 'hooks'
import { useEffect } from 'react'
import { Item } from 'typings'
import { useFormStateContext } from 'ui'
import { FormAliasKeys } from 'ui/providers/useFormAlias.constate'
import { ShippingApplyTo, ShippingKeys } from '../../../typings'

type Props = {
  state: FormState
}

/**
 * Move shipping values from shipping methods condition to the shipping benefit
 */
export function useShippingsRelation(props: Props) {
  const { state } = props
  const { form: mainForm } = useFormStateContext()

  const shippingsFromCondition = useWatchAlias<Item[]>({
    form: mainForm,
    key: FormAliasKeys.shippingMethods,
  })

  useEffect(() => {
    const shippingsFromBenefit: Item[] | undefined = state.getValues(
      ShippingKeys.selectedMethods
    )

    if (shippingsFromCondition?.length && !shippingsFromBenefit) {
      state.setValue(ShippingKeys.applyTo, ShippingApplyTo.selected)
      state.setValue(ShippingKeys.selectedMethods, shippingsFromCondition)
    }
  }, [shippingsFromCondition, state])
}
